import { NavigationItem } from '@models';

export const NavigationConfig: NavigationItem[] = [
  { label: 'Dashboard', route: 'dashboard', icon: 'chart-pie' },
  { label: 'Appointments', route: 'appointments', icon: 'calendar-month' },
  { label: 'Chat', route: 'chat', icon: 'messages-outline' },
  { label: 'Forms', route: 'forms', icon: 'clipboard-list' },
  { label: 'My Programs', route: 'my-programs', icon: 'book' },
  { label: 'Documents', route: 'documents', icon: 'file-text-outline' },
  {
    label: 'Protocols and lab results',
    route: 'lab-results',
    icon: 'test-tube-diagonal-outline',
  },
  { label: 'Payments', route: 'billing', icon: 'wallet' },
  { label: 'Membership', route: 'membership', icon: 'membership-outline' },
  { label: 'Settings', route: 'settings', icon: 'cog' },
];
